import { render, staticRenderFns } from "./weekly_chart_component.vue?vue&type=template&id=d879324e&scoped=true"
import script from "./weekly_chart_component.vue?vue&type=script&lang=js"
export * from "./weekly_chart_component.vue?vue&type=script&lang=js"
import style0 from "./weekly_chart_component.vue?vue&type=style&index=0&id=d879324e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879324e",
  null
  
)

export default component.exports